(function () {
  var KEYS = ['name', 'birth_date', 'birth_time', 'place_name', 'lat', 'lng', 'timezone'];
  // Store "Style" option label -> preview API style code (same as SKU)
  var STYLE_CODES = { Midnight: 'MID', Minimal: 'MIN', Vintage: 'VIN' };

  function selectedStyle() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (STYLE_CODES[radios[i].value]) return STYLE_CODES[radios[i].value];
    }
    var options = document.querySelectorAll('select option:checked');
    for (var j = 0; j < options.length; j++) {
      if (STYLE_CODES[options[j].value]) return STYLE_CODES[options[j].value];
    }
    return 'MID';
  }

  function init(root) {
    var endpoint = root.dataset.searchEndpoint;
    var f = function (k) { return root.querySelector('[data-natal-field="' + k + '"]'); };
    var name = f('name'), date = f('birth_date'), time = f('birth_time'), unknown = f('unknown_birth_time'), place = f('place_query');
    var results = root.querySelector('[data-natal-place-results]');
    var selected = null, controller = null, timer = null, previewTimer = null, lastPreviewUrl = '';
    var preview = root.querySelector('[data-natal-preview]');
    var previewImg = root.querySelector('[data-natal-preview-img]');
    var previewStatus = root.querySelector('[data-natal-preview-status]');

    function refreshPreview() {
      clearTimeout(previewTimer);
      previewTimer = setTimeout(function () {
        var complete = name.value.trim() && date.value && selected && (unknown.checked || time.value);
        if (!complete) return;
        var url = new URL(root.dataset.previewEndpoint);
        var values = {};
        KEYS.forEach(function (k) { values[k] = root.querySelector('[data-property-key="' + k + '"]').value; });
        Object.keys(values).forEach(function (k) { url.searchParams.set(k, values[k]); });
        url.searchParams.set('style', selectedStyle());
        if (url.toString() === lastPreviewUrl) return;
        lastPreviewUrl = url.toString();
        preview.hidden = false;
        preview.classList.add('is-loading');
        previewStatus.textContent = 'Drawing your sky…';
        var img = new Image();
        img.onload = function () {
          if (lastPreviewUrl !== url.toString()) return;
          previewImg.src = img.src;
          preview.classList.remove('is-loading');
          previewStatus.textContent = 'Preview only — your print is rendered in full resolution after you order.';
        };
        img.onerror = function () {
          preview.classList.remove('is-loading');
          previewStatus.textContent = 'Preview is busy right now — you can still add to cart.';
          lastPreviewUrl = '';
        };
        img.src = url.toString();
      }, 450);
    }

    function sync() {
      var values = {
        name: name.value.trim(),
        birth_date: date.value,
        birth_time: unknown.checked || !time.value ? 'unknown' : time.value,
        place_name: selected ? selected.place_name : '',
        lat: selected ? String(selected.lat) : '',
        lng: selected ? String(selected.lng) : '',
        timezone: selected ? selected.timezone : ''
      };
      KEYS.forEach(function (k) { root.querySelector('[data-property-key="' + k + '"]').value = values[k]; });
      place.setCustomValidity(selected ? '' : 'Please choose your birthplace from the list.');
      time.setCustomValidity(unknown.checked || time.value ? '' : 'Enter a birth time or tick "I don\'t know the birth time".');
      refreshPreview();
    }

    function render(places) {
      results.innerHTML = '';
      places.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'natal-place-option';
        b.textContent = p.place_name;
        b.addEventListener('click', function () {
          selected = p;
          place.value = p.place_name;
          results.hidden = true;
          place.setAttribute('aria-expanded', 'false');
          sync();
        });
        results.appendChild(b);
      });
      results.hidden = places.length === 0;
      place.setAttribute('aria-expanded', places.length ? 'true' : 'false');
    }

    function search(q) {
      if (controller) controller.abort();
      if (q.trim().length < 2) { render([]); return; }
      controller = new AbortController();
      var url = new URL(endpoint);
      url.searchParams.set('q', q);
      fetch(url.toString(), { credentials: 'omit', signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('search failed'); return r.json(); })
        .then(function (data) { render(data.places || []); })
        .catch(function (e) { if (e.name !== 'AbortError') render([]); });
    }

    place.addEventListener('input', function () {
      selected = null;
      sync();
      clearTimeout(timer);
      timer = setTimeout(function () { search(place.value); }, 200);
    });
    [name, date, time].forEach(function (el) { el.addEventListener('input', sync); });
    unknown.addEventListener('change', function () {
      time.disabled = unknown.checked;
      if (unknown.checked) time.value = '';
      sync();
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) results.hidden = true; });
    // Re-render the preview when the shopper switches style (variant)
    document.addEventListener('change', function (e) {
      if (e.target && STYLE_CODES[e.target.value]) refreshPreview();
    });
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-natal-birth-form]:not([data-natal-ready])').forEach(function (root) {
      root.setAttribute('data-natal-ready', '');
      init(root);
    });
  }

  initAll();
  // Forms inserted after load (re-rendered sections, dialogs) get wired up too
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
